import { ProjectFinancialsContractType } from 'api/project';
import { FilterableField } from 'components/organisms/tasks/fields';
import { Step, StepsData, StrategyOptions } from './types';

export const getNextIndex = (steps: Step[], selectedStep: Step) => {
  const index = steps.findIndex((item) => item.id === selectedStep.id);
  const nextIndex = (index + 1) % steps.length === 0 ? 0 : index + 1;

  return nextIndex;
};

export const getPreviousIndex = (steps: Step[], selectedStep: Step) => {
  const currentIndex = steps.findIndex((item) => item.id === selectedStep.id);

  return currentIndex - 1;
};

export const isMaximumMarginDisabled = ({
  strategy,
  financialContractType,
  isRateCardEnabled,
  hasAccessToMaximizeMargin,
}: {
  strategy;
  financialContractType: ProjectFinancialsContractType;
  isRateCardEnabled: boolean;
  hasAccessToMaximizeMargin: boolean;
}) => {
  if (strategy.value === StrategyOptions.MaximumMargin) {
    if (financialContractType === ProjectFinancialsContractType.SUBSCRIPTION) {
      return false;
    }
    if (
      financialContractType === ProjectFinancialsContractType.NONBILLABLE ||
      !hasAccessToMaximizeMargin
    ) {
      return true;
    }
    if (
      (financialContractType !== ProjectFinancialsContractType.FIXED &&
        !isRateCardEnabled) ||
      !hasAccessToMaximizeMargin
    ) {
      return true;
    }
  }

  return false;
};

export const getTooltipText = (
  financialContractType: ProjectFinancialsContractType,
) => {
  if (financialContractType === ProjectFinancialsContractType.NONBILLABLE) {
    return 'maximum_margin_disabled_for_non_billable_project';
  }

  return 'rate_cards_not_enabled_text';
};

export const getUpdatedRowData = (selectedRow) => {
  return {
    allocationStartDate: selectedRow.allocatedDates.startDate,
    allocationEndDate: selectedRow.allocatedDates.endDate,
    allocatedMinutes: selectedRow.allocatedMinutes,
    team: {
      teamId: selectedRow.id,
      teamName: selectedRow.teamName,
      roleId: selectedRow.roleId,
    },
    dateEditable: selectedRow.isDatesEditable,
    resolved: false,
    simpleSearchFilter: selectedRow.simpleSearchFilter,
    isNoMatchFoundShown: false,
  };
};

export const updateRowDataWithNoMatchFoundStatus = (
  stepsData: StepsData,
): StepsData => {
  const updatedRowData = stepsData.rows.map((item) => ({
    ...item,
    isNoMatchFoundShown: !!(
      item.allocationStartDate &&
      item.allocationEndDate &&
      item.allocatedMinutes &&
      !item.user?.userId
    ),
  }));

  return { ...stepsData, rows: updatedRowData };
};

export const getMarginColor = (margin: number) => {
  if (margin <= 0) {
    return 'var(--red-60)';
  }

  return 'var(--green-50)';
};

export const getUtilizationColor = (utilization: number) => {
  if (utilization <= 100) {
    return 'var(--green-50)';
  }

  return 'var(--red-60)';
};

export const removeTeamMembersIfNoAccess = ({
  fields,
  peopleIHaveAccess,
}: {
  fields: FilterableField[];
  peopleIHaveAccess: number[];
}) => {
  return fields?.map((field: any) =>
    field?.fieldName === 'teamMembers'
      ? {
          ...field,
          metaData: {
            ...field?.metaData,
            users: {
              ...field?.metaData?.users,
              active_user_ids: field?.metaData?.users?.active_user_ids?.filter(
                (x) => peopleIHaveAccess?.includes(x),
              ),
              non_external_user_ids:
                field?.metaData?.users?.non_external_user_ids?.filter((x) =>
                  peopleIHaveAccess?.includes(x),
                ),
            },
          },
        }
      : field,
  );
};
